import { ToneCountWithUser } from '@/utils/helpers';
import ToneCardStack from '../ToneCard/ToneCardStack';
import Carousel from '../Carousel/Carousel';

interface Props {
  tones: ToneCountWithUser[];
  /** Cards in the lg+ grid. The carousel below it always shows every tone. */
  gridLimit?: number;
}

// The carousel bleeds into the page gutter, so this expects an ancestor with
// `px-4 sm:px-6`.
export const ToneCardRow = ({ tones, gridLimit = 4 }: Props) => (
  <>
    <div className="hidden lg:grid grid-cols-2 md:grid-cols-4 gap-8">
      {tones.slice(0, gridLimit).map((tone, index) => (
        <ToneCardStack key={tone.id} tone={tone} position={index} className="min-w-0" />
      ))}
    </div>
    <div className="lg:hidden -mx-4 sm:-mx-6">
      <Carousel cardWidth="w-64" gap="gap-4" gutterLeft="w-4 sm:w-6" gutterRight="w-4 sm:w-6">
        {tones.map((tone, index) => (
          <ToneCardStack key={tone.id} tone={tone} position={index} className="min-w-0" />
        ))}
      </Carousel>
    </div>
  </>
);
